import { useState, useEffect, useRef } from 'react'
import { MinimalButton } from '@ovasabi/ui-minimal'
import { ChowModal, Money } from '../../components/chow'
import { formatPayLabel } from '../../lib/paystack'

export interface PaystackModalProps {
  open: boolean
  amountMinor: number
  description?: string
  onClose: () => void
  onSuccess: () => Promise<void> | void
}

export const PaystackModal = ({ open, amountMinor, description, onClose, onSuccess }: PaystackModalProps) => {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const submitting = useRef(false)
  useEffect(() => { if (open) setError('') }, [open])
  const submit = async () => {
    if (submitting.current) return
    submitting.current = true
    setBusy(true)
    setError('')
    try { await onSuccess(); onClose() }
    catch (err) { setError(err instanceof Error ? err.message : 'Payment could not be verified. Check Orders before trying again.') }
    finally { submitting.current = false; setBusy(false) }
  }
  return (
    <ChowModal open={open} title="Secure checkout" maxWidth={400} onClose={() => { if (!busy) onClose() }}>
      <div style={{ display: 'grid', gap: '1rem' }}>
        <p>{description ?? 'You’ll pay in Paystack’s secure window. Your order is confirmed as soon as Paystack tells us the payment went through.'}</p>
        <Money amount={amountMinor / 100} tone="brand" size="lg" />
        {error && <p role="alert">{error}</p>}
        <MinimalButton tone="brand" loading={busy} disabled={busy} onClick={() => void submit()}>
          {busy ? 'Waiting for payment verification…' : formatPayLabel(amountMinor)}
        </MinimalButton>
      </div>
    </ChowModal>
  )
}
